import { ParticipantWithMedicalInterview } from '@breathelife/types';
import { createContext, PropsWithChildren, ReactElement, useContext } from 'react';
import { useFetchParticipantsWithMedicalInterviewQuery } from '../ReactQuery/Participants/participants.queries';

export type ParticipantsContextValue = {
  participants: ParticipantWithMedicalInterview[];
};

export const ParticipantsContext = createContext<ParticipantsContextValue | undefined>(undefined);

type ParticipantsContextProviderProps = {
  applicationId: string;
};
export function ParticipantsContextProvider({
  applicationId,
  children,
}: PropsWithChildren<ParticipantsContextProviderProps>): ReactElement {
  const { data } = useFetchParticipantsWithMedicalInterviewQuery(applicationId);

  return <ParticipantsContext.Provider value={{ participants: data || [] }}>{children}</ParticipantsContext.Provider>;
}

export function useParticipantsContext(): ParticipantsContextValue {
  const participantsContext = useContext(ParticipantsContext);
  if (!participantsContext) {
    throw new Error('useParticipantsContext must be used within a ParticipantsContext');
  }
  return participantsContext;
}
